// HOC shared by both register and account flows
import { withNewCamperForm } from 'components/account/Campers/New'

import UI from './UI'

// in reg flow, report progress to GTM and redirect to campers list
export default withNewCamperForm({
  onSuccess: data =>
    window.dataLayer &&
    window.dataLayer.push({ event: 'register.createCamper' }),
  redirect: '/campers'
})(UI)
